/**
 * Appraisal field limits aligned with HRM Core entity [MaxLength] / varchar sizes.
 * TEXT columns use a practical client cap (still under MySQL TEXT ~64KB).
 */

export const APPRAISAL_LIMITS = {
  name: 200,
  description: 2000,
  behaviorText: 2000,
  headline: 500,
  learningMethod: 1000,
  fileName: 255,
  fileUrl: 1000,
  buttonText: 100,
  buttonLink: 1000,
  timeText: 50,
  longText: 10000,
  comment: 5000,
  ratingLetter: 50,
};

export const clampLen = (value, max) => {
  const s = value == null ? "" : String(value);
  if (!max || s.length <= max) return s;
  return s.slice(0, max);
};

/** Returns error message if empty after trim; otherwise null. */
export const requiredTrimmed = (value, label = "This field") => {
  if (!String(value ?? "").trim()) {
    return `${label} is required.`;
  }
  return null;
};

/** Returns error if over max; otherwise null. */
export const maxLenError = (value, max, label = "This field") => {
  const len = String(value ?? "").length;
  if (max > 0 && len > max) {
    return `${label} must be ${max} characters or fewer.`;
  }
  return null;
};

/**
 * Validate a map of { key: { value, required?, max, label } }.
 * Returns first error string or null.
 */
export const validateFields = (specs) => {
  for (const spec of specs) {
    const { value, required, max, label } = spec;
    if (required) {
      const err = requiredTrimmed(value, label);
      if (err) return err;
    }
    if (max) {
      const err = maxLenError(value, max, label);
      if (err) return err;
    }
  }
  return null;
};

export const hasAnyTrimmed = (...values) =>
  values.some((v) => String(v ?? "").trim().length > 0);
